<script lang="ts">
import type { CalendarCellProps } from '..'
import { CalendarCell } from '..'

export interface DatePickerCellProps extends CalendarCellProps {}
</script>

<script setup lang="ts">
const props = defineProps<DatePickerCellProps>()
</script>

<template>
  <CalendarCell v-bind="props">
    <slot />
  </CalendarCell>
</template>
